import { CampaignTypeStateValue } from "v2/services/contractLifecycle.service";

/** Espelho do contrato de GET/PUT /v2/workspaces/:workspaceId/apps/campaigns (backend, campaigns/config). */
export const CONFERIR_MOVIMENTACOES_TEMPLATE_ID = "304b63d5-e134-4bae-9fef-f1bf37ce1d3e";

export type PanelCampaignType = "contributario" | "plan_extension";

export interface PanelParams {
  version: 1;
  waitForImplantation?: boolean;
  sendAutomatically?: boolean;
  cadence?: { steps: { entryAfterDays: number; resendEveryDays: number; maxResends: number }[] };
}

export interface ExtensionRules {
  eligibleTerminationReasons: string[];
  minContributionMonths: number | null;
  windowDays: number | null;
}

export type ExtensionKitLookup =
  | { status: "FOUND"; kits: { id: string; name: string; scenario: string | null; generic: boolean }[]; onlyGeneric: boolean }
  | { status: "NONE" }
  | { status: "CATALOG_UNAVAILABLE" };

export interface CampaignPanelType {
  type: PanelCampaignType;
  label: string;
  isActive: boolean;
  startDate: string | null;
  params: PanelParams;
  state: CampaignTypeStateValue;
  eligible: boolean;
  /** Motivo pelo qual o tipo não pode ser ligado agora; null = livre. */
  turnOnBlocked: string | null;
  /**
   * Aviso ao ligar em contrato já Em operação. null = não se aplica; { wouldHold: N } = N pessoas passam a ficar
   * Em espera pela campanha a partir desta noite; { wouldHold: null } = aplica-se, mas não foi possível contar.
   * Só leitura: o Salvar não o envia.
   */
  turnOnCheck: null | { wouldHold: number | null };
  waitingCount: number | null;
  defaultCadence: { recipient: string; entryAfterDays: number; resendEveryDays: number; maxResends: number }[];
  extension: null | { rules: ExtensionRules | null; contractContributes: boolean | null; planContribution: { contributing: number; total: number } | null; kit: ExtensionKitLookup; engineAvailable: boolean };
}

export interface CampaignPanelState {
  templateId: string;
  workspaceActivityId: string | null;
  /** Falso: o PUT responderia 403 (só a corretora do contrato, admin ou super usuário grava). */
  canEdit: boolean;
  types: CampaignPanelType[];
}

export interface CampaignDraftItem {
  type: PanelCampaignType;
  isActive: boolean;
  params: PanelParams;
  reason: string | null;
  extensionRules?: ExtensionRules;
}

/** Item enviado no PUT: o rascunho mais o isActive que o painel carregou do servidor (o backend responde 409 se não bate com o gravado). */
export type CampaignSaveItem = CampaignDraftItem & { baseIsActive: boolean };

export type CampaignDraft = Record<string, CampaignDraftItem>;
